import CharacterTidbits from './CharacterTidbits';

export default CharacterTidbits;
export { CharacterTidbits };
